<template>
  <div class="d-flex user-preview">
    <div class="c-avatar c-avatar--lg">
      <VUserIcon
        :src="currentUser.avatar"
        class="c-avatar-img user-preview__avatar"
      />
    </div>

    <div class="ml-3 d-flex flex-column justify-content-center">
      <h6 class="mb-1 user-preview__username">{{ currentUser.username }}</h6>
      <span class="info-text user-preview__email">{{ currentUser.email }}</span>
    </div>
  </div>
</template>
<script>
import { createAuthStoreMixin, authStore } from '@/mixins/authStoreMixin'

export default {
  name: 'VUserPreview',

  mixins: [
    createAuthStoreMixin()
  ],

  computed: {
    currentUser () {
      return this[authStore.getterTypes.GETTER_USER]
    }
  }
}
</script>
